module.exports = __webpack_public_path__ + "line.567f57385ea3dde2c9ae.gif";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/line.gif
// module id = 735
// module chunks = 9